module.exports = __webpack_public_path__ + "static/media/startup-freelancer-hero-image.9aee3acb.webp";